export const loadConfig = async () => {
    try {
        const response = await fetch(`${import.meta.env.BASE_URL}config.json`);

        if (!response.ok) {
            throw new Error(`Error loading config.json: ${response.status}`);
        }

        const config = await response.json();
        return config;
    } catch (error) {
        console.error('Error fetching or parsing config.json:', error);
        //    throw error; // Re-throw the error
        return null;
    }
};

